import * as React from 'react'

export const useStateHook = <State>(initialState: State) =>
  React.useReducer<(state: State, update: Partial<State>) => State>(
    (state, update) => ({
      ...state,
      ...update
    }),
    initialState
  )
